<template>
  <div class="item-shop-slot">
    <div class="item-shop-img">
      <div class="item">
        <span class="notify-badge" v-if="itemShopInfo.IsHot > 0">HOT</span>
        <q-img
          v-if="!isNightMarket"
          :src="itemShopInfo.ImgPath" 
        >
        <q-tooltip class="text-body2" v-if="itemShopInfo.ItemDisc" anchor="bottom middle" self="top middle">
          <p v-html="itemShopInfo.ItemDisc"></p>
        </q-tooltip>
      </q-img>
    </div>
      <q-img
        v-if="isNightMarket"
        :src="itemShopInfo.shop.ImgPath" 
      >
        <q-tooltip class="text-body2" v-if="itemShopInfo.ItemDisc" anchor="bottom middle" self="top middle">
          <p v-html="itemShopInfo.ItemDisc"></p>
        </q-tooltip>
      </q-img>
    </div>
    <div class="details" v-if="!isNightMarket">
      <div class="item-name">
        <span>{{ itemShopInfo.ItemName }}</span>
      </div>
      <div class="others">
        <span v-if="itemShopInfo.ItemSec !== '3'">Stock: <strong class="stock"> {{ itemShopInfo.ItemStock }}</strong></span>
        <span v-if="isDicounted">
          <strong :style="isDicounted ? 'text-decoration-line: line-through; font-style: italic;' : ''" >
            Price: 
            <span class="price">
              {{ itemShopInfo.ItemPrice + ' '  + getPointType }} 
            </span>
          </strong>
          <b class="discount">{{ discountItem }}</b>
        </span>
        <span>Price: <strong class="price"> {{ price + ' '  + getPointType }}</strong></span>
        <div class="actions" v-if="isLoggedIn">
          <q-btn label="Buy" class="buy_btn" @click="buyConfirmation = true"/>
          <q-btn label="Gift" class="buy_btn" @click="buyConfirmationGift = true"/>
          <q-btn label="Details" class="buy_btn" v-if="itemShopInfo.ImagePreviewURL" @click="previewModal = true" />
          <q-btn icon="delete" class="buy_btn" @click="deleteConfirm = true" v-if="isLoggedIn && isAdmin && itemShopInfo.ItemSec !== '3'"/>
          <q-btn icon="edit" class="buy_btn" @click="editModal = true" v-if="isLoggedIn && isAdmin && itemShopInfo.ItemSec !== '3'"/>
          <q-btn icon="send" class="buy_btn" @click="sendToAllModal = true" v-if="isLoggedIn && isAdmin && itemShopInfo.ItemSec !== '3'"/>
        </div>
      </div>
    </div>

    <div class="details" v-else>
      <div class="item-name">
        <span>{{ itemShopInfo.shop.ItemName }}</span>
      </div>
      <div class="others">
        <span>Price: <strong class="price-nm"> {{ Number(itemShopInfo.shop.ItemPrice).toLocaleString('en-US') }}</strong></span>
        <div class="actions" v-if="isLoggedIn">
          <q-btn label="Buy" class="buy_btn" @click="buyConfirmationNightMarket = true" :disable="Number(itemShopInfo.Status) === 1"/>
        </div>
      </div>
    </div>

    <q-dialog
      v-model="previewModal"
      transition-show="scale"
      transition-hide="scale"
    >
    <q-card class="text-black" style="width: 100%; height: min-content;">
      <q-card-section>
        <div class="text-h6">Details</div>
      </q-card-section>

      <q-card-actions align="right" class="bg-white text-teal">
        <q-img :src="itemShopInfo.ImagePreviewURL"/>
      </q-card-actions>

    </q-card>
    </q-dialog>

    <q-dialog
      v-model="buyConfirmation"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Confirmation</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Are you sure you want to buy <b>{{ itemShopInfo.ItemName }}</b> with price of
            <b>{{ price }} {{ getPointType }}</b>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="BUY"
            @click="buy"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="buyConfirmationNightMarket"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Confirmation</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Are you sure you want to buy <b>{{ itemShopInfo.shop.ItemName }}</b> with price of
            <b>{{ Number(itemShopInfo.shop.ItemPrice).toLocaleString('en-US') }} Gold</b>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-select
            v-model="buyer"
            :options="characters"
            option-value="ChaNum"
            option-label="ChaName"
            hint="Select Character"
            label="Select Character"
            map-options
            dense
            outlined
            class="select"
          />
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            :disabled="!buyer"
            flat
            label="BUY"
            @click="buyNightMartket"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="buyConfirmationGift"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Confirmation</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Are you sure you want to gift <b>{{ itemShopInfo.ItemName }}</b> with price of
            <b>{{ price }} {{ getPointType }}.</b>
            <br><br>
            If you are sure, Please Input UserName of user you want to gift to.

            <q-input
              v-model="userName"
              outlined
              rounded
              class="user-name"
              input-style="font-size:12px"
              color="grey"
              placeholder="Username"
              dense
            />
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="BUY"
            @click="buy"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="deleteConfirm"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Delete Confirmation</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Are you sure you want to delete <b>{{ itemShopInfo.ItemName }}</b>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="Delete"
            @click="deleteItem"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="editModal"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 500px">
        <q-card-section>
          <div class="text-h6">Edit Item</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          You are about to Edit <b>{{ itemShopInfo.ItemName }} ({{ itemId }})</b>
        </q-card-section>
        
        <q-card-section class="q-pt-none">
          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.ItemName"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Name"
            dense
            hint="Item Name"
          />

          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.ItemPrice"
            type="Number"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Price"
            dense
            hint="Item Price"
          />

          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.ItemStock"
            type="Number"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Stock"
            dense
            hint="Item Stock"
          />

          <q-select
            style="margin-top: 8px;"
            v-model="itemDetails.ItemSec"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Stock"
            dense
            label="Item Section (VP/EP)"
            hint="Item Section"
            :options="sections"
          />

          <q-select
            style="margin-top: 8px;"
            v-model="itemDetails.DiscountType"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Discount Type"
            dense
            label="Dicount Type"
            hint="Discount Type"
            :options="['percentage']"
          />

          <q-select
            style="margin-top: 8px;"
            v-model="itemDetails.ItemCtg"
            map-options
            option-value="value"
            option-label="label"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Category"
            dense
            label="Category"
            hint="Category"
            emit-value
            :options="itemShopTabs"
          />

          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.ItemDiscount"
            type="Number"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Discount"
            dense
            hint="Item Discount"
          />

          <q-editor
            v-model="itemDetails.ItemDisc"
            min-height="10rem"
            :toolbar="[
              ['bold', 'italic', 'underline'],
              ['token', 'hr', 'link', 'custom_btn']
            ]"
            hint="Item Description"
          />

          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.NightMarketPrice"
            type="Number"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Night Market Price Gold"
            dense
            hint="if you change this price, item will be added to random item, if you start the Night Market!"
          />

          <q-file
            ref="fileRef"
            rounded
            outlined
            v-model="image"
            style="display: none"
            @update:model-value="handleUpload('main')"
          />

          <q-file
            ref="fileRefPreview"
            rounded
            outlined
            v-model="imagePreview"
            style="display: none"
            @update:model-value="handleUpload('preview')"
          />

          <div>
            <q-img
              @click="$refs.fileRef.pickFiles()"
              :src="itemDetails.ImgPath"
              spinner-color="white"
              style="height: 140px; max-width: 150px; cursor: pointer; margin-top: 16px;"
            />
          </div>
          <div>
            <q-img
              @click="$refs.fileRefPreview.pickFiles()"
              :src="itemDetails.ImagePreviewURL"
              spinner-color="white"
              style="height: 140px; max-width: 150px; cursor: pointer; margin-top: 16px;"
            />
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="Update"
            @click="updateItem"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="sendToAllModal"
      transition-show="scale"
      transition-hide="scale"
      class="send-to-all"
    >
      <q-card class="text-black" style="width: 400px">
        <q-card-section>
          <div class="text-h6">Send to all</div>
        </q-card-section>

        <q-card-section class="q-pt-none card-section">
          <q-list>
            <q-item tag="label" v-ripple>
              <q-item-section avatar>
                <q-radio v-model="sendToAllType" val="send_to_all_registered" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Send to all Registered Player</q-item-label>
              </q-item-section>
            </q-item>
            <q-item tag="label" v-ripple>
              <q-item-section avatar>
                <q-radio v-model="sendToAllType" val="send_to_all_online" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Send to all Online Player</q-item-label>
              </q-item-section>
            </q-item>
            <q-item tag="label" v-ripple>
              <q-item-section avatar>
                <q-radio v-model="sendToAllType" val="send_to_all_online_24hr" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Send to Player logged in 24hr</q-item-label>
              </q-item-section>
            </q-item>
            <q-item tag="label" v-ripple>
              <q-item-section avatar>
                <q-radio v-model="sendToAllType" val="send_to_all_selected" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Send to all selected user</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>

        <q-card-section class="q-pt-none card-section" v-if="sendToAllType === 'send_to_all_selected'">
          Input Username
          <div
            style="width: 300px; border: 1px solid #ccc; min-height: 34px; display:flex; flex-wrap: wrap; align-content: space-between;"
          >
            <div
              style="margin:4px;background: #e0e0e0; padding:0px 4px; border: 1px solid #ccc; border-radius: 3px; display:flex;align-items: center;"
              v-for="(chip, i) of chips" :key="chip.label"
              >
                {{chip}}
                <i class="material-icons" style="cursor: pointer;opacity: .56;margin-left:8px;" @click="deleteChip(i)">clear</i>
            </div>
            <input style="flex: 1 1 auto; width:10px; border: none; outline: none; padding:4px;" v-model="currentInput" @keypress.enter="saveChip" @keydown.delete="backspaceDelete">
          </div>
        </q-card-section>
        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn
            style="background-color: #FFC108; color: black"
            flat label="Send"
            @click="sendItem"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
      
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash'

export default {
  name: 'ItemShopSlot',
  data () {
    return {
      buyConfirmation: false,
      buyConfirmationGift: false,
      deleteConfirm: false,
      buyConfirmationNightMarket: false,
      editModal: false,
      sendToAllType: '',
      sendToAllModal: false,
      chips:[],
      currentInput: '',
      userName: '',
      sections: ['VP', 'EP'],
      image: null,
      imagePreview: null,
      buyer: null,
      previewModal: false,
      itemDetails: {
        ItemName: '',
        ItemStock: 0,
        ItemPrice: 0,
        ItemSec: 'VP',
        ImgPath: null,
        ItemDiscount: 0,
        DiscountType: '',
        NightMarketPrice: 0,
        ItemCtg: 0,
        ItemDisc: null,
        IsHot: 0,
        ImagePreviewURL: null
      },
      ItemIDs: {
        Main: 0,
        Sub: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser',
      characters: 'user/getCharacters',
      isAdmin: 'user/isAdmin'
    }),
    isDicounted () {
      return Number(this.itemShopInfo.ItemDiscount) > 0
    },
    discountItem () {
      const discountPrice = this.itemShopInfo.ItemDiscount
      const discountType = this.itemShopInfo.DiscountType === 'percentage' ? '%': ''

      const text = '-' + discountPrice + '' + discountType
      
      return text
    },
    price () {
      if (this.itemShopInfo.ItemDiscount && this.itemShopInfo.DiscountType) {
        const discount = Number(this.itemShopInfo.ItemDiscount)

        if (this.itemShopInfo.DiscountType === 'percentage') {
          const discountPercentage = Number(this.itemShopInfo.ItemPrice) * (discount / 100)

          const discountedPrice = this.itemShopInfo.ItemPrice - discountPercentage

          return Math.round(discountedPrice)
        } else {
          return this.itemShopInfo.ItemPrice - discount
        }
      }

      return this.itemShopInfo.ItemPrice
    },
    getPointType () {
      if (this.itemShopInfo.ItemSec === "3") return 'PHP'

      return this.itemShopInfo.ItemSec == 1 ? 'GT' : 'EP'
    },
    itemShopTabs () {
      const tabs = this.getItemShopTabs()

      tabs.splice(0, 1)

      return tabs
    },
    itemId () {
      return this.ItemIDs.Main + '_' + this.ItemIDs.Sub
    },
    UserID () {
      return this.$route.query.userId;
    }
  },
  watch: {
    async editModal (val) {
      if (val) {
        this.itemDetails = cloneDeep(this.itemShopInfo)
        this.itemDetails.ItemSec = cloneDeep(this.getPointType)
        this.itemDetails.ItemCtg = Number(this.itemShopInfo.ItemCtg)
        this.itemDetails.ItemDisc = this.itemShopInfo.ItemDisc
        this.itemDetails.IsHot = Number(this.itemShopInfo.IsHot)

        this.ItemIDs.Main = this.itemDetails.ItemMain
        this.ItemIDs.Sub = this.itemDetails.ItemSub
      }
    }
  },
  methods: {
    ...mapActions({
      requestBuy: 'itemShop/requestBuy',
      requestBuyTopup: 'itemShop/requestBuyTopup',
      requestDelete: 'itemShop/requestDelete',
      requestUpdate: 'itemShop/requestUpdate',
      buyNightMarketItem: 'itemShop/buyNightMarketItem',
      getAuthUser: 'user/getAuthUser',
      isLoggedIn: 'user/isLoggedIn',
      requestUserCheckByUserName: 'user/requestUserCheckByUserName',
      requestSendItemToAll: 'user/requestSendItemToAll'
    }),
    async saveChip() {
      const {chips, currentInput, set} = this;
      await this.requestUserCheckByUserName(currentInput)
      .then(() => {
        ((set && chips.indexOf(currentInput) === -1) || !set) && chips.push(currentInput);
        this.currentInput = '';
      })
      .catch(() => {
        this.currentInput = '';
      })
      
    },
    deleteChip(index) {
      this.chips.splice(index, 1);
    },
    backspaceDelete({which}) {
      which == 8 && this.currentInput === '' && this.chips.splice(this.chips.length - 1);
    },
    async handleUpload (type) {
      if (type === 'main') {
        if (this.image) {
          this.imageUrl = URL.createObjectURL(this.image);
        }

        await this.createBase64Image(this.image)
      } else if (type === 'preview') {
        if (this.image) {
          this.imageUrl = URL.createObjectURL(this.imagePreview);
        }

        await this.createBase64ImagePreview(this.imagePreview)
      }
    },
    createBase64Image: function(FileObject) {
      const reader = new FileReader();

      reader.onload = (event) => {
        this.itemDetails.ImgPath = event.target.result;
      }

      reader.readAsDataURL(FileObject);
    },
    createBase64ImagePreview: function(FileObject) {
      const reader = new FileReader();

      reader.onload = (event) => {
        this.itemDetails.ImagePreviewURL = event.target.result;
      }

      reader.readAsDataURL(FileObject);
    },
    async buyNightMartket () {
      if (!this.buyer) {
        this.$q.notify({
          position: 'top-right',
          message: 'Please select character first.',
          type: 'negative',
        })

        return
      }

      const { ChaMoney, ChaOnline } = this.buyer

      if (Number(ChaOnline) === 1) {
        this.$q.notify({
          position: 'top-right',
          message: 'Please logout first ingame.',
          type: 'negative',
        })

        return
      }

      if (Number(ChaMoney) < Number(this.itemShopInfo.shop.ItemPrice)) {
        this.$q.notify({
          position: 'top-right',
          message: 'Not enough gold to buy this item.',
          type: 'negative',
        })

        return
      }

      this.$q.loading.show()

      await this.recaptchaLoad('buynightmarket')

      const parameter = {
        itemId: this.itemShopInfo.ID,
        chaNum: this.buyer.ChaNum
      }

      await this.buyNightMarketItem(parameter)
        .then(async response => {
          this.buyConfirmationNightMarket = false

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })
          
          await this.getAuthUser()
        })
        .catch(error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative',
          })
        })

      this.$q.loading.hide()
    },
    async buy () {
      this.$q.loading.show()

      const parameter = {
        userName: this.userName,
        productId: this.itemShopInfo.ProductNum,
        UserID: this.UserID
      }

      await this.recaptchaLoad('buyiytem')

      if (this.itemShopInfo.ItemSec === '3') {
        await this.requestBuyTopup(parameter)
          .then(response => {
            window.location.href = response.data.data.redirect_link
          })
          .catch(error => {
            this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative',
            })
          })
        this.$q.loading.hide()
        return
      }
      await this.requestBuy(parameter)
        .then(async (response) => {
          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })

          await this.recaptchaLoad('buyiytem')

          await this.getAuthUser()

          this.buyConfirmation = false;
          this.buyConfirmationGift = false;
          this.userName = ''

          this.$emit('success-request')

          this.$q.loading.hide()
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })

          this.$q.loading.hide()
        })
    },
    async deleteItem () {
      this.$q.loading.show()

      await this.recaptchaLoad('deleteitem')

      await this.requestDelete(this.itemShopInfo.ProductNum)
        .then(async response => {
          await this.recaptchaLoad('deleteitem')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })

          this.$emit('success-request')
          this.deleteConfirm = false
          this.$q.loading.hide()
        })
        .catch(async error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })

          this.$q.loading.hide()
        })
    },
    async updateItem () {
      this.$q.loading.show()

      await this.recaptchaLoad('updateitem')

      await this.requestUpdate(this.itemDetails)
        .then(async (response) => {
          await this.recaptchaLoad('updateitem')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })

          this.buyConfirmation = false;
          this.buyConfirmationGift = false;
          this.editModal = false;
          this.userName = ''

          this.$emit('success-request')

          this.$q.loading.hide()
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })

          this.$q.loading.hide()
        })
    },
    async sendItem () {
      
      if (this.sendToAllType === 'send_to_all_selected') {
        if (this.chips.length === 0) {
          this.$q.notify({
            position: 'top-right',
            message: 'Please Select User!',
            type: 'negative'
          })

          return
        }
      }

      const payload = {
        type: this.sendToAllType,
        users: this.chips,
        ProductNum: this.itemShopInfo.ProductNum
      }

      await this.requestSendItemToAll(payload)
        .then(response => {
          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })
        })
        .catch (error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })
        })
    }
  },
  props: {
    itemShopInfo: {
      require: true,
      type: Object
    },
    isNightMarket: {
      require: false,
      default: false,
      type: Boolean,
    }
  }
}
</script>

<style lang="scss">
.item-shop-slot {
  display: grid;
  grid-template-columns: .3fr 1fr;
  gap: 16px;
  max-width: 100%;
  margin-top: 16px;

  .card-section {
    .chip-container {
      width: 400px;
      border: 1px solid #ccc;
      min-height: 34px;
      display:flex;
      flex-wrap: wrap;
      align-content: space-between;
      .chip {
        margin:4px;
        background: #e0e0e0;
        padding:0px 4px;
        border: 1px solid #ccc;
        border-radius: 3px;
        display:flex;
        align-items: center;
        i {
          cursor: pointer;
          opacity: .56;
          margin-left:8px;
        }
      }
      input {
        flex: 1 1 auto;
        width:30px;
        border: none;
        outline: none;
        padding:4px;
      }
    }
  }

  .item-shop-img {
    margin-left: auto;

    .item {
      position:relative;
      display:inline-block;
    }

    .q-img {
      width: 50px;
      height: 50px;
    }
    .notify-badge{
      position: absolute;
      background:red;
      left: 25px;
      top: -10px;
      font-size: 10px;
      text-align: center;
      border-radius: 20px 20px 20px 20px;
      color:white;
      padding: 3px 10px;
      z-index: 2;
    }
  }

  .details {
    .item-name {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2px;

      span {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        white-space: nowrap;
        color: white;
      }
    }  

    .others {
      margin-top: 8px;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 1px;
      color: white;

      .price {
        color: green;
      }

      .price-nm {
        color: orange;
      }

      .discount {
        margin-left: 8px;
        background-color: red;
        font-style: italic;
        border-radius: 8px;
        padding: 2px;
        font-size: 10px;
        letter-spacing: normal;
      }

      .actions {
        .buy_btn {
          max-width: 50px;
          margin-right: 8px;
          background-color: #FFC108;
          color: black;
          font-size: 9px;
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>